import { render, staticRenderFns } from "./StrategyAction.vue?vue&type=template&id=6f9810bc"
import script from "./StrategyAction.vue?vue&type=script&lang=js"
export * from "./StrategyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports